'use strict';

var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var mergeOpts = require('merge-options');

var toMfsPath = require('./utils/to-mfs-path.js');

var errCode = require('err-code');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var defaultOptions = {
  offset: 0,
  length: Infinity
};

function createRead(context) {
  function mfsRead(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options = mergeOptions(defaultOptions, options);
    return _defineProperty({}, Symbol.asyncIterator, function () {
      var _read = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var mfsPath, result, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, buf;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _awaitAsyncGenerator(toMfsPath.toMfsPath(context, path, options));

              case 2:
                mfsPath = _context.sent;
                _context.next = 5;
                return _awaitAsyncGenerator(ipfsUnixfsExporter.exporter(mfsPath.mfsPath, context.repo.blocks));

              case 5:
                result = _context.sent;

                if (!(result.type !== 'file')) {
                  _context.next = 8;
                  break;
                }

                throw errCode__default["default"](new Error("".concat(path, " was not a file")), 'ERR_NOT_FILE');

              case 8:
                if (result.content) {
                  _context.next = 10;
                  break;
                }

                throw errCode__default["default"](new Error("Could not load content stream from ".concat(path)), 'ERR_NO_CONTENT');

              case 10:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context.prev = 12;
                _iterator = _asyncIterator(result.content({
                  offset: options.offset,
                  length: options.length
                }));

              case 14:
                _context.next = 16;
                return _awaitAsyncGenerator(_iterator.next());

              case 16:
                if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                  _context.next = 23;
                  break;
                }

                buf = _step.value;
                _context.next = 20;
                return buf;

              case 20:
                _iteratorAbruptCompletion = false;
                _context.next = 14;
                break;

              case 23:
                _context.next = 29;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](12);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 29:
                _context.prev = 29;
                _context.prev = 30;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 34;
                return _awaitAsyncGenerator(_iterator.return());

              case 34:
                _context.prev = 34;

                if (!_didIteratorError) {
                  _context.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context.finish(34);

              case 38:
                return _context.finish(29);

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[12, 25, 29, 39], [30,, 34, 38]]);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }());
  }

  return withTimeoutOption.withTimeoutOption(mfsRead);
}

exports.createRead = createRead;